<template>
    <div class='email-box'>
        <EmailMarket class="white"></EmailMarket>
        <GoodAndFalse class="black"></GoodAndFalse> 
        <EmailCase class="white"></EmailCase>
    </div>
</template>
<script>
import EmailMarket from '@/components/main/project/emailmarketing'//引入邮件营销说明

import GoodAndFalse from '@/components/main/project/goodandfalse'//引入评价  

import EmailCase from '@/components/main/project/emailCase'//引入客户案例  
export default{
    name:'Email',
    data(){
        return{

        }
    },
    components:{
        EmailMarket,
        GoodAndFalse,
        EmailCase
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/main/porject/email.vue